import React, { InputHTMLAttributes } from 'react';
import { CheckboxContainer } from './styles';

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  onChange?: (e: any) => void;
  checked?: boolean;
  value?: string;
  id: string;
}

const Checkbox = ({ name, checked, onChange, value, id }: Props) => {
  return (
    <CheckboxContainer>
      <input
        id={id}
        value={value}
        type="checkbox"
        onChange={onChange}
        name={name}
        checked={checked}
      />
      <span />
    </CheckboxContainer>
  );
};

export default Checkbox;
